import React, { useContext, useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { useNotifications } from 'utils/hooks';
import {
  AllNotifications,
  BannerPortal,
  MarkAllAsRead,
  UnreadNotifications
} from './components';
import NavItem from '../NavItem';
import { AuthContext } from 'context/AuthContext';
import { ReactComponent as NotificationsIcon } from 'assets/img/icons/new/notifications.svg';
import { ReactComponent as NotificationsDot } from 'assets/img/icons/new/notification_dot.svg';

const TABS = ['Unread', 'All'];

export default function Notifications() {
  const { appType } = useContext(AuthContext);

  return appType.retex ? <NotificationsContent /> : null;
}

function NotificationsContent() {
  const {
    fetchAllNotifications = () => {},
    loadedAllNotifications,
    isFetchingAllNotifications,
    unreadNotificationsList
  } = useNotifications();
  const [tab, setTab] = useState(TABS[0]);

  useEffect(() => {
    if (
      tab === TABS[1] &&
      !loadedAllNotifications &&
      !isFetchingAllNotifications
    ) {
      fetchAllNotifications();
    }
  }, [
    tab,
    loadedAllNotifications,
    isFetchingAllNotifications,
    fetchAllNotifications
  ]);

  const listClassname = tabValue =>
    cn(styles.notificationList, {
      'd-none': tab === tabValue
    });

  const hasUnreadNotifications = useMemo(
    () =>
      Array.isArray(unreadNotificationsList)
        ? unreadNotificationsList.some(({ is_read }) => !is_read)
        : false,
    [unreadNotificationsList]
  );

  return (
    <>
      <BannerPortal />
      <UiKit.Dropdown className={styles.container}>
        <UiKit.Dropdown.Trigger
          caret={false}
          className={styles.trigger}
          component={NavItem}
        >
          <NotificationsIcon
            className={styles.icon}
            data-prompt={hasUnreadNotifications}
          />
          <If test={hasUnreadNotifications}>
            <NotificationsDot className={styles.dot} />
          </If>
        </UiKit.Dropdown.Trigger>
        <UiKit.Dropdown.Menu align="right" className={styles.menu}>
          <div className={styles.title}>Notifications</div>
          <div className={styles.header}>
            <UiKit.Tabs value={tab} onChange={setTab}>
              <UiKit.Tabs.Tab label="Unread" value={TABS[0]} />
              <UiKit.Tabs.Tab label="All" value={TABS[1]} />
            </UiKit.Tabs>
            <If test={tab === TABS[0]}>
              <MarkAllAsRead />
            </If>
          </div>
          <div className={styles.content} id="scrollableDiv">
            {<UnreadNotifications className={listClassname(TABS[1])} />}
            {<AllNotifications className={listClassname(TABS[0])} />}
          </div>
        </UiKit.Dropdown.Menu>
      </UiKit.Dropdown>
    </>
  );
}
